/**
 * region for libraries*/
import React, { Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { DateRangePicker } from "react-dates";
import moment from "moment";
import 'react-dates/initialize';

/**
 * region for styles*/
import 'react-dates/lib/css/_datepicker.css';

/**
 * region for helpers*/
import list from '../../helpers/list';
import typing from '../../helpers/typing';


export class DateFilter extends Component {
    static displayName = DateFilter.name;

    constructor(props) {
        super(props);

        this.state = {
            dropdownOpenDate: this.props.dropdownOpenDate,
            startDate: null,
            endDate: null,
            selectedDateValue: null,
            focusedInput: null
        }

    }

    handleToggle() {
        const self = this;
        if (self.props.onToggle) {
            self.props.onToggle();
        }
    }

    handleFilterByDate(dateItem, event) {
        event.preventDefault();
        if (dateItem) {
            this.setState({ startDate: dateItem.beginDate, endDate: dateItem.endDate, selectedDateValue: dateItem.value });
            if (this.props.onChangeDate) {
                this.props.onChangeDate(event, dateItem.beginDate, dateItem.endDate, dateItem.value);
                this.handleToggle();
            }
        } else {
            this.setState({ startDate: null, endDate: null, selectedDateValue: null });
            if (this.props.onChangeDate) {
                this.props.onChangeDate(event, null, null, null);
                this.handleToggle();
            }
        }
    }

    handleDateChange = ({ startDate, endDate }) =>
        this.setState({ startDate, endDate });

    handleFocusChange = focusedInput => this.setState({ focusedInput });

    isOutsideRange = () => false;

    handleOnClickApplyDate(event) {
        event.preventDefault();
        this.setState({
            selectedDateValue: 'custom_dates'
        });
        if (this.props.onChangeDate) {
            this.props.onChangeDate(event, this.state.startDate.toDate(), this.state.endDate.toDate(), null);
            this.handleToggle();
        }
    }

    render() {

        const self = this;

        const cursorDate = new Date();
        cursorDate.setMonth(cursorDate.getMonth() - 1);
        const firstOfThisMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const firstOfLastMonth = new Date(cursorDate.getFullYear(), cursorDate.getMonth(), 1);
        const lastOfLastMonth = new Date(firstOfThisMonth - 1);
        const firstOfThisYear = new Date(new Date().getFullYear(), 0, 1);

        const firstOfLastYear = new Date(new Date().getFullYear() - 1, 0, 1);
        const lastOfLastYear = new Date(new Date().getFullYear() - 1, 11, 31);

        const datesRanges = [
            {
                label: 'This month',
                value: 'this_month',
                beginDate: firstOfThisMonth,
                endDate: new Date()
            },
            {
                label: 'Last month',
                value: 'last_month',
                beginDate: firstOfLastMonth,
                endDate: lastOfLastMonth,
            },
            {
                label: 'This year',
                value: 'this_year',
                beginDate: firstOfThisYear,
                endDate: new Date(),
            },
            {
                label: 'Last year',
                value: 'last_year',
                beginDate: firstOfLastYear,
                endDate: lastOfLastYear,
            },
            {
                label: 'Custom dates',
                value: 'custom_dates',
                beginDate: self.state.BEGINDATE,
                endDate: self.state.ENDDATE,
            }
        ];

        const optionsDates = datesRanges.map(function (dateItem) {
            let boundClick = self.handleFilterByDate.bind(self, dateItem);
            let dateKey = `date_${dateItem.value}`;
            let dateClass = 'dropdown-item';
            if (self.state.selectedDateValue && dateItem.value === self.state.selectedDateValue) {
                dateClass += ' active';
                if (dateItem.value !== 'custom_dates') {
                    datesRanges.beginDate = typing.convertToDateShortMonth(dateItem.beginDate);
                    datesRanges.endDate = typing.convertToDateShortMonth(dateItem.endDate);
                }
            }
            if (dateItem.value !== 'custom_dates') {
                return (
                    <a className={dateClass} key={dateKey} href="#/" onClick={boundClick}>{dateItem.label}</a>
                );
            }
            return '';
        });

        const boundFilterAllDatesClick = this.handleFilterByDate.bind(this, null);
        let allDatesOptionClass = 'dropdown-item';
        let currentDateSelectedText = 'All dates';
        if (self.state.selectedDateValue) {
            const dateRange = list.filterOne(datesRanges, row => row.value === this.state.selectedDateValue);
            currentDateSelectedText = dateRange.label;
        }
        else {
            allDatesOptionClass += ' active';
        }

        let iconCalendar = <i className="far fa-calendar-plus font-size-xs"></i>
        return (
            <ButtonDropdown className="dropdown-dates" isOpen={this.props.dropdownOpenDate} toggle={this.handleToggle.bind(this)}>
                <DropdownToggle caret className="btn btn-secondary dropdown-toggle">
                    {currentDateSelectedText}
                </DropdownToggle>
                <DropdownMenu>
                    <a className={allDatesOptionClass} onClick={boundFilterAllDatesClick} href="#/">All</a>
                    <DropdownItem divider />
                    {optionsDates}
                    <DropdownItem divider />
                    <div className="date-custom-range">
                        <DropdownItem className="date-custom-range">Custom range:</DropdownItem>
                        <DropdownItem divider />
                        <DateRangePicker
                            endDate={typing.isEmpty(this.state.endDate) ? undefined : moment(this.state.endDate)}
                            endDateId="endDate"
                            focusedInput={this.state.focusedInput}
                            isOutsideRange={this.isOutsideRange}
                            onDatesChange={this.handleDateChange}
                            onFocusChange={this.handleFocusChange}
                            startDate={typing.isEmpty(this.state.startDate) ? undefined : moment(this.state.startDate)}
                            startDateId="startDate"
                            startDatePlaceholderText="From"
                            endDatePlaceholderText="To"
                            displayFormat="MMM DD YYYY"
                            customInputIcon={iconCalendar}
                            noBorder={true}
                            small={true} />
                        <button type="submit" className="btn btn-block btn-warning" onClick={this.handleOnClickApplyDate.bind(this)}>Apply date range</button>
                    </div>
                </DropdownMenu>
            </ButtonDropdown >
        );
    }

}
